<template>
  <span>
  <Sldebar
    :data="sidebardata"
    :searchOpen="searchOpen"
    @searchClose="searchClose"
    :popular="data.popular_searches"
  />
  <header
    id="site-header"
    class="site-header"
    :class="{ open: isOpen }"
  >
    <div class="content-max-width">
      <a v-show="shouldShowLogo" href="/" class="logo">
        <img src="/images/svgs/logo.svg" :alt="data.site_name" class="dark"/>
        <img id="mainlogo" :src="logoPath" :alt="data.site_name" class="light"/>
      </a>
    </div>

    <div :class="[shouldShowLogoMobile ? '': 'mobile-hide']" class="mobile-logo" >
      <img src="/images/svgs/logo.svg" :alt="data.site_name" />
      <!-- <img src="/images/svgs/logo-white.svg" class="white-logo" :alt="data.site_name" /> -->
    </div>
    <div class="nav-controls">
      <button id="global-search-mobile" class="search" @click="openSearch()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g>
            <g>
              <path

                d="M3.861 9.872c0 2.47.937 4.727 2.474 6.46L0 22.542 1.465 24l6.36-6.256c.008-.008.013-.017.02-.025a10.026 10.026 0 0 0 6.086 2.025C19.483 19.744 24 15.315 24 9.872 24 4.428 19.483 0 13.93 0 8.379 0 3.862 4.428 3.862 9.872zm10.07 7.923c-4.457 0-8.082-3.555-8.082-7.923 0-4.37 3.625-7.923 8.082-7.923C18.387 1.949 22 5.503 22 9.872c0 4.368-3.613 7.923-8.07 7.923"
              />
            </g>
          </g>
        </svg>
      </button>
      <button id="humburger-menu" class="hamburger" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <nav>
      <a href="/" class="open-logo">
        <img src="/images/svgs/logo.svg" :alt="data.site_name" />
      </a>

      <hr />
      <div class="menu-wrap md:flex">
        <div class="links">
          <!-- <li v-for="(link, index) of nav" :key="index">
            <a :href="link.url">
              {{ link.title }}
            </a>
          </li> -->
          <a href="/what-we-do">{{data.nav_text['What We Do'] ? data.nav_text['What We Do'] : 'What We Do'}}</a>
          <a href="/whanau">{{data.nav_text['Whānau'] ? data.nav_text['Whānau'] : 'Whānau'}}</a>
          <a href="/about-us">{{data.nav_text['About Us'] ? data.nav_text['About Us'] : 'About Us'}}</a>
          <a href="/careers">{{data.nav_text['Careers'] ? data.nav_text['Careers'] : 'Careers'}}</a>
          <a href="/awards">{{data.nav_text['Awards'] ? data.nav_text['Awards'] : 'Awards'}}</a>
          <a href="/projects" class="proj-linkto">{{data.nav_text['Projects'] ? data.nav_text['Projects'] : 'Projects'}}</a>
          <a href="/news-insights">{{data.nav_text['News & Insights'] ? data.nav_text['News & Insights'] : 'News & Insights'}}</a>
          <a href="/our-history">{{data.nav_text['Our History'] ? data.nav_text['Our History'] : 'Our History'}}</a>
          <a href="/contact">{{data.nav_text['Contact'] ? data.nav_text['Contact'] : 'Contact'}}</a>
          <a href="/carbon-neutral">{{data.nav_text['Carbon Neutral'] ? data.nav_text['Carbon Neutral'] : 'Carbon Neutral'}}</a>

        </div>
        <div class="hidden projects md:block">
          <div class="header"><a href="/projects">{{data.nav_text['Projects'] ? data.nav_text['Projects'] : 'Projects'}}</a></div>
          <div class="body">
            <div class="location">
              <div class="project-links">
                <h6>By Location</h6>
                <a v-for="(location) of data.locations" :href="'/projects?location=' + location.label">{{ location.label }}</a>

                <!-- <a href="/projects?region=whangarei">Whangarei</a>
                <a href="/projects?region=tauranga">Tauranga</a>
                <a href="/projects?region=hamilton">Hamilton</a>
                <a href="/projects?region=wellington">Wellington</a>
                <a href="/projects?region=nelson">Nelson</a>
                <a href="/projects?region=christchurch">Christchurch</a>
                <a href="/projects?region=dunedin">Dunedin</a>-->
              </div>
            </div>
            <div class="type">
              <h6>By Type</h6>
              <div class="project-links">
                <a v-for="(type) of data.types" :href="'/projects?sector=' + type.label">{{ type.label }}</a>
                <!--<a href="/projects">Community & Recreation</a>
                <a href="/projects">Council & Government</a>
                <a href="/projects"></a>
                <a href="/projects"></a>
                <a href="/projects"></a>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</span>


</template>

<script>
import Sldebar from "./Sidebar"

export default {
  props: {
    menu: Array,
    data: Object,
    sidebardata: Object
  },
  components: {
    Sldebar
  },
  data: () => ({
    isOpen: false,
    nav: [],
    searchOpen: false
  }),

  computed: {
    logoPath () {
      return window.location.pathname.includes('/projects/')
      || window.location.pathname.includes('/careers')
      || window.location.pathname.includes('/what-we-do')
      || window.location.pathname.includes('/')
      // return window.location.pathname.includes('/projects/')
        ? '/images/svgs/logo-white.svg'
        : '/images/svgs/logo.svg'
    },

    shouldShowLogo () {
      return this.$root.scrollTop < 118
    },
    shouldShowLogoMobile () {
      return this.$root.scrollTop < 47
    },
  },

  mounted() {
    this.nav = this.menu
    // console.log(this.data.locations)
  },

  methods: {
    openSearch() {
      this.searchOpen=true
      console.log('test')
      this.$children[0].$refs.searchbar.focus()
    },
    toggleMenu() {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        document.getElementsByTagName("body")[0].style.overflow = 'hidden'
        //console.log(document.getElementsByTagName("body")[0].style)
        console.log('hidden')
      } else {
        document.getElementsByTagName("body")[0].style.overflow = 'auto'
        console.log('show')
      }

    },
    searchClose() {
      console.log('close')
      this.searchOpen = false
    }

  },
}
</script>
